<div class="boxes">
  <span
    class="tag"
    (click)="selectBox.emit(allBox)"
    [ngClass]="{ selected: selectedBox === allBox }"
  >
    {{ 'PLAYLIST.ADD_TRACKS.ALL' | translate }}
  </span>
  @for (box of bacsGroups$ | async; track $index) {
    <span
      *ngIf="box.count"
      class="tag"
      (click)="selectBox.emit(box.name)"
      [ngClass]="{ selected: box.name === selectedBox }"
    >
      {{ box.translated$ | async }}
    </span>
  }
</div>
